import image from "fragments/image"
import masSearchItem from "fragments/mas/masSearchItem"
import gql from "graphql-tag"

const homeVideoSearchItem = gql`
  ${image}
  ${masSearchItem}

  fragment HomeVideoSearchItem on HomeVideoSearchItem {
    editions
    id
    isBluRay
    isUHD
    images {
      ...Image
    }
    mas {
      ...MASSearchItem
    }
    name
    newsCount
    homeVideoReview {
      id
      isPublished
      publishedAt
    }
  }
`

export default homeVideoSearchItem
